import React, {Component} from 'react'
import { Upload, Icon, message } from 'antd';

export default class FieldFileInput  extends Component{
    constructor(props) {
        super(props);
        //this.onChange = this.onChange.bind(this);
    }



    uploadFile(e) {


        return new Promise((resolve, reject) => {
            const {input: {onChange, value}} = this.props;
            //onChange(e.target.files[0]);

            //console.log(e);
            //window.setTimeout(() => {resolve(true);}, 2000);

             let allFiles = [];

             if(value.length > 0) {
                 allFiles = value;
             }
             

             this.getBase64(e, (result) => {
                 //allFiles.push(Object.assign({},e, {base64: result}));
                 allFiles.push(Object.assign({},{uid: e.uid}, {name: e.name}, {base64: result}, {size: e.size}));
                 //allFiles.push(...e.uid, ...e.name, {base64: result});
                 onChange(allFiles);
                 resolve(true);

             });
        });
    }



    /*customRequest = ({ onSuccess, onError, onProgress, file }) => {
        this.uploadFile(file)
            .then(() => {
                onSuccess(null, file);
            })
            .catch(() => {
                // call onError();
            });
    };*/


    customRequest = ({ onSuccess, onError, onProgress, file }) => {


        const {input: {onChange, value}} = this.props;

        let allFiles = [];

        if(value.length > 0) {
            allFiles = value;
        }

        let alreadyExists = false;

        if(Array.isArray(value)) {
            alreadyExists= value.filter(f => {return f.name === file.name}).length > 0;
        }

        if(alreadyExists) {
            allFiles = allFiles.filter((actFile => { return actFile.uid !== file.uid; }));
            onChange(allFiles);
            return new Promise((resolve, reject) => { resolve(false); }).then(() => {onError("Diese Datei existiert bereits!", false, file);});
        }


        const isValidFormat = (file.type === 'application/pdf' || file.type === 'image/jpeg' || file.type === 'image/tiff');
        if (!isValidFormat) {
            message.error('Bitte verwenden Sie ein gültiges Dateiformat: PDF, JPEG oder TIF.');
        }
        const isValidSize = file.size / 1024 / 1024 < 20;
        if (!isValidSize) {
            message.error('Sie haben die maximale Dateigröße von 20MB überschritten.');
        }

        if(!(isValidFormat && isValidSize)) {
            allFiles = allFiles.filter((actFile => { return actFile.uid !== file.uid; }));
            onChange(allFiles);
            return new Promise((resolve, reject) => { resolve(false); }).then(() => {onError("Diese Datei existiert bereits!", false, file);});
        }

        this.uploadFile(file)
            .then(() => {
                onSuccess(null, file);
            })
            .catch(() => {
                // call onError();
                //onError("Diese Datei existiert bereits!", "done", file);
                onError();
            });



        //return isValidFormat && isValidSize;
    };





    getBase64(file, cb) {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            cb(reader.result)
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }


    onRemove = (file) => {
        return new Promise((resolve, reject) => {
            const {input: {onChange, value}} = this.props;
            //onChange(e.target.files[0]);

            //console.log(e);
            //window.setTimeout(() => {resolve(true);}, 2000);

            let allFiles = [];

            if(value.length > 0) {
                allFiles = value;
            }

            allFiles = allFiles.filter((actFile => { return actFile.uid !== file.uid; }));
            onChange(allFiles);
            resolve(true);
        });
    };

    beforeUpload = (file) => {


        const {input: {onChange, value}} = this.props;

        let allFiles = [];

        if(value.length > 0) {
            allFiles = value;
        }

        let alreadyExists = false;

        if(Array.isArray(value)) {
            alreadyExists= value.filter(f => {return f.name === file.name}).length > 0;
        }
        console.log(alreadyExists);

        ///if(alreadyExists) {
            allFiles = allFiles.filter((actFile => { return actFile.uid !== file.uid; }));
            onChange(allFiles);
            return false;
        //}


        const isValidFormat = (file.type === 'application/pdf' || file.type === 'image/jpeg' || file.type === 'image/tiff');
        if (!isValidFormat) {
            message.error('Bitte verwenden Sie ein gültiges Dateiformat: PDF, JPEG oder TIF.');
        }
        const isValidSize = file.size / 1024 / 1024 < 20;
        if (!isValidSize) {
            message.error('Sie haben die maximale Dateigröße von 20MB überschritten.');
        }

        if(!(isValidFormat && isValidSize)) {
            allFiles = allFiles.filter((actFile => { return actFile.uid !== file.uid; }));
            onChange(allFiles);
        }

        return isValidFormat && isValidSize;
    };


    render(){
        const { input: { value } } = this.props;
        const {input,label, required, meta, } = this.props;  //whatever props you send to the component from redux-form Field
        return(
            <div><label>{label}</label>
                <div>
                    { /*<input
                        ref="file"
                        type='file'
                        accept='*'
                        onChange={this.onChange}
                    />*/ }
                    <Upload.Dragger listType={'picture'} name="file" customRequest={this.customRequest} onRemove={this.onRemove} ref="file" accept="application/pdf, image/jpeg, image/tiff">
                        <p className="ant-upload-drag-icon">
                            <Icon type="inbox" />
                        </p>
                        <p className="ant-upload-text">Klicken oder ziehen Sie die Datei in diesen Bereich, um sie hochzuladen.</p>
                        <p className="ant-upload-hint">Unterstützte Dateiformate: PDF, JPEG, TIF</p>
                    </Upload.Dragger>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/FileInput.js